"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useMemo, useState } from "react";
import { PoolsFiltersProvider, useFavorites, usePools } from "../hooks";
import { PoolsTableTanstack } from "./table";
export function FavoritesView() {
  const $ = _c(19);
  const [favoritesSearch, setFavoritesSearch] = useState("");
  const {
    data: t0,
    isLoading: favoritesLoading
  } = useFavorites();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const favoritesData = t1;
  const {
    data: poolsData,
    isLoading: poolsLoading
  } = usePools();
  const isLoading = favoritesLoading || poolsLoading;
  let t2;
  bb0: {
    if (!poolsData || !favoritesData.length) {
      t2 = undefined;
      break bb0;
    }
    let t3;
    if ($[2] !== favoritesData) {
      t3 = new Set(favoritesData.map(_temp));
      $[2] = favoritesData;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    const favoritePoolIds = t3;
    let t4;
    if ($[4] !== favoritePoolIds || $[5] !== poolsData.pools) {
      let t5;
      if ($[7] !== favoritePoolIds) {
        t5 = pool => favoritePoolIds.has(pool.pool.toLowerCase());
        $[7] = favoritePoolIds;
        $[8] = t5;
      } else {
        t5 = $[8];
      }
      t4 = poolsData.pools.filter(t5);
      $[4] = favoritePoolIds;
      $[5] = poolsData.pools;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    const favoritedPools = t4;
    let t5;
    if ($[9] !== favoritedPools || $[10] !== poolsData) {
      t5 = {
        ...poolsData,
        pools: favoritedPools,
        total: favoritedPools.length
      };
      $[9] = favoritedPools;
      $[10] = poolsData;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t2 = t5;
  }
  const favoritedPoolsData = t2;
  if (isLoading) {
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex min-h-[400px] items-center justify-center"><p className="text-text-tertiary">Loading favorites...</p></div>;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  if (!favoritedPoolsData || favoritedPoolsData.pools.length === 0) {
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex min-h-[400px] flex-col items-center justify-center gap-4"><p className="text-lg font-semibold text-text-primary">No favorites yet</p><p className="max-w-sm text-center text-sm text-text-tertiary">Start favoriting pools to keep your best opportunities in one place.</p><Link href="/pools" className="font-medium text-brand-secondary underline">Explore pools</Link></div>;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    return t3;
  }
  let t3;
  if ($[14] !== favoritesSearch) {
    t3 = {
      value: favoritesSearch,
      onChange: setFavoritesSearch
    };
    $[14] = favoritesSearch;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== favoritedPoolsData || $[17] !== t3) {
    t4 = <PoolsFiltersProvider><PoolsTableTanstack overridePoolsData={favoritedPoolsData} hideFilters={true} enableUnfavoritingAnimation={true} favoritesSearch={t3} /></PoolsFiltersProvider>;
    $[16] = favoritedPoolsData;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}
function _temp(poolAddress) {
  return poolAddress.toLowerCase();
}